module.exports = __webpack_public_path__ + "static/media/04_360.eb95b632.jpeg";